import {db, analytics} from './firebase';
import {push, ref} from  'firebase/database';
import { logEvent } from '@firebase/analytics';

export class UserApi{
    static writeUserData(name: string, email: string, phoneNumber: string) {
        push(ref(db, 'users'), {
          fullName: name,
          email: email.trim(),
          phoneNumber : phoneNumber
        });
    } 
}

export class AnalyticsApi{
  static logEvent(event: string){
    logEvent(analytics, event);
  }
  
}
